import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IdentityFacade } from '@bp/admins-shared/domains/identity';

import { IntroFacade } from '../../../state';

@Component({
	selector: 'bp-create-password-page',
	templateUrl: './create-password-page.component.html',
	styleUrls: [ './create-password-page.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatePasswordPageComponent {

	constructor(
		public introFacade: IntroFacade,
		public identityFacade: IdentityFacade,
	) { }

}
